he.posts.locations.init = function () {

};